export interface PhoneStatus {
  description: StatusOptions;
  color: string;
  needGoodConnection: boolean;
  verifyDuplicatedExtension: boolean;
  hasTooltip?: boolean;
  tooltipDescription?: string;
}

export enum StatusOptions {
  ONLINE = 'ONLINE',
  BUSY = 'BUSY',
  PAUSE = 'PAUSE',
  ON_PAUSE = 'ON_PAUSE',
  OFFLINE = 'OFFLINE',
  SOFTPHONE_CONNECTION_FAILED = 'SOFTPHONE_CONNECTION_FAILED',
  SOFTPHONE_TRY_CONNECTION = 'SOFTPHONE_TRY_CONNECTION',
  SOFTPHONE_CONNECTION_REJECTED = 'SOFTPHONE_CONNECTION_REJECTED',
  SOFTPHONE_WEBSOCKET_DISCONNECTED = 'SOFTPHONE_WEBSOCKET_DISCONNECTED',
}
